// extracted by mini-css-extract-plugin
export default {"body":"profile_edit_panel___body___d9c64d91"};